var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.22 6.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#6aa549;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SHOWFILTER"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.62,
    cy: 3.33,
    r: 3.08
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "13.26 1.09 11.12 3.22 13.07 5.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1.98 1.09 4.12 3.22 2.17 5.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.4,3.25h3.82"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.12,
    y1: 3.22,
    y2: 3.22
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContain);
export default __webpack_public_path__ + "static/media/contain.d6d8a49e.svg";
export { ForwardRef as ReactComponent };